interface ErrorMessageProps {
  message: string;
  variant?: 'error' | 'success' | 'info';
}

const ErrorMessage = ({ message, variant = 'error' }: ErrorMessageProps) => {
  return (
    <div className="notice" data-variant={variant} role={variant === 'error' ? 'alert' : 'status'}>
      {message}
    </div>
  );
};

export default ErrorMessage;
